module.exports = __webpack_public_path__ + "files/f025d4b337be24a669772e91f7ef1980.png";